import { Component,OnInit,OnDestroy,AfterViewInit } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
  FvmsCommonService
  ,FvmsApiDtgReportCarService
  ,FvmsApiAuthService
  ,FvmsExcelService
} from "src/app/shared/service";
import {
    FilterDateDiff
    ,FilterDist
    ,FilterSecToTime
} from "src/app/shared/filter";
import {
    dtgCarTypeList
    ,PagingInfo
} from "src/app/shared/vo";

@Component({
    templateUrl: './dtg.report.car.all.component.html'
    ,providers: [FilterDateDiff,FilterDist,FilterSecToTime]
})
export class DtgReportCarAllComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    userGroupId:number;
    dayDiff:number = 1;
    dtgCarTypeList = dtgCarTypeList;
    listItem:any[];
    searchDtgCarType:string = "";
    searchValue:string;
    pagingInfo:PagingInfo = new PagingInfo();
    excelPagingInfo:PagingInfo = new PagingInfo();
    currentUserInfo:any;
    maxDriveDtCnt:number = 0;
    selectedDate:any;


    constructor(
        private modalService: NgbModal
        ,private fvmsCommonService: FvmsCommonService
        ,private fvmsApiDtgReportCarService:FvmsApiDtgReportCarService
        ,private filterDateDiff:FilterDateDiff
        ,private filterSecToTime:FilterSecToTime
        ,private filterDist:FilterDist
        ,private fvmsExcelService:FvmsExcelService
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.pagingInfo.pageSize = 15;
        this.excelPagingInfo.pageSize = 9999999;

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo && this.companyInfo){
                    if(this.companyInfo.companyId !== companyInfo.companyId){
                        this.companyInfo = companyInfo;
                    }
                }else{
                    this.companyInfo = companyInfo;
                }
                this.clickSearch();
            });

        this.fvmsCommonService.subscribeDateInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(dateInfo => {
                // this.changeDate();
                this.clickSearch();
            });
    }

    ngOnInit() {
        // this.changeDate();
        // this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }

    ngAfterViewInit() {
    }

    gerSearchInfo(){
        return {
            companyId:this.companyInfo?.companyId || 0
            ,dtgEid:this.companyInfo?.dtgEid || ""
            ,dtgTeamId:this.currentUserInfo?.teamId || ""
            ,searchDateFrom:this.fvmsCommonService.getDateFromIsoReserve()
            ,searchDateTo:this.fvmsCommonService.getDateToIsoReserve()
            ,dtgCarType:this.searchDtgCarType
            ,searchValue:this.searchValue
            ,dtgGroupByRegDtYy:"Y"
            ,dtgGroupByRegDtMm:"Y"
            ,dtgGroupByRegDtDd:"Y"
            ,dtgGroupByUnitId:"Y"
        };
    }

    reloadListItem(){
        this.fvmsCommonService.setIsLoading(true);
        this.maxDriveDtCnt = 0;
        this.fvmsApiDtgReportCarService.getListReportCar(this.gerSearchInfo(),this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                this.listItem = []
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        this.listItem = apiResponse.resultValue;
                        // console.log("listItem",this.listItem);
                        let size = this.listItem.length;
                        for(let a=0;a<size;a++){
                            let item = this.listItem[a];
                            if(item.dtgDriveDtCnt > this.maxDriveDtCnt){
                                this.maxDriveDtCnt = item.dtgDriveDtCnt;
                            }
                        }
                    }
                    this.pagingInfo = apiResponse.pagingInfo;
                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }

    changeDate(){
        this.selectedDate = {
            searchDateFrom:this.fvmsCommonService.getDateFromIsoReserve()
            ,searchDateTo:this.fvmsCommonService.getDateToIsoReserve()
        };
    }

    clickSearch(){
        this.pagingInfo.curPage = 1;
        this.changeDate();
        this.reloadListItem();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.clickSearch();
    }

    changeCarType(e){
        this.clickSearch();
    }

    callbackClickPageNumber(selectedPage:number){
        this.pagingInfo.curPage = selectedPage;
        this.changeDate();
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.clickSearch();
    }

    // 리스트 운행율
    getDriveRatio(item){
        return Math.round((item.dtgDriveDtCnt / this.maxDriveDtCnt) * 100) || 0;
    }

    excelDownload(){
        this.fvmsCommonService.setIsLoading(true);
        this.fvmsApiDtgReportCarService.getListReportCar(this.gerSearchInfo(),this.excelPagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.fvmsExcelService.excelDownload(this.convertExcelJson(apiResponse.resultValue),"car_driving_log");

                }
                this.fvmsCommonService.setIsLoading(false);
            });
    }
    convertExcelJson(dataList:any[]){
        let resultList = [];
        dataList.map((v) => {
            console.log(v);
            resultList.push({
                "차량번호":v.dtgCarNo
                ,"구분":v.dtgCarTypeNm
                ,"운행시간":this.filterSecToTime.transform(v.dtgRegDtDuration,"HH:mm:ss")
                ,"운행거리(km)":this.filterDist.transform(Number(v.dtgDistAccumul))
                ,"운행일":v.dtgDriveDtCnt
                ,"운행율(%)":v.dtgDriveRatio
                ,"트립수":v.dtgTripCnt
                ,"최근주행일시":v.dtgRegDtTo
                ,"주행운전자수":v.dtgDriverLcsNoCnt
                ,"연료소모량(L)":this.filterDist.transform(Number(v.dtgOilUseAccumul))
                ,"최근온도1(°C)":v.dtgTemper1To
                ,"최근온도2(°C)":v.dtgTemper2To
            })
        });
        return resultList;
    }
}
